import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useFormContext, Controller } from 'react-hook-form';
import {
  Card,
  CardContent,
  CircularProgress,
  Button,
  TextField,
  Typography,
  Icon,
} from '@material-ui/core';

import InputMask from 'react-input-mask';

import { instanceAxios } from '../../../InstanceAxios';

import { formatMoney } from '../../../utils/common';
import { handle_payment } from '../helpers';

import FlagCards from '../components/FlagCards';

import { useStyles } from './formCartao.style';

function FormCartao(props) {
  const classes = useStyles(props);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [cupomObj, setCupomObj] = useState(null);

  const [assinatura, setAssinatura] = useState([]);
  const [nomeAssinatura, setNomeAssinatura] = useState('');
  const [valorAssinatura, setValorAssinatura] = useState(0.0);

  const [servico, setServico] = useState([]);
  const [nomeServico, setNomeServico] = useState('');
  const [valorServico, setValorServico] = useState(0.0);

  const { cpf, cnpj, email } = props.state.user;
  const username = props.state.user.nome;

  const methods = useFormContext();
  const { control, formState, getValues } = methods;
  const { errors, isValid } = formState;

  const [message, setMessage] = useState({
    text: '',
    icon: '',
    color: '',
  });

  const { signaturePlan } = props.state;

  useEffect(() => {
    const get_data_to_payment_signature = () => {
      setLoading(true);
      // dados assinatura
      const plan_signature = props.state.signaturePlan;
      setNomeAssinatura(plan_signature.nome);
      setValorAssinatura((parseFloat(plan_signature.valor) / 100).toFixed(2));
      setAssinatura(plan_signature);

      // dados servico
      const service_item = props.state?.item;
      if (service_item) {
        setNomeServico(service_item.nome);
        setValorServico(service_item.valor);
        setServico(service_item);
      } else {
        setServico(null);
      }

      setLoading(false);
    };

    get_data_to_payment_signature();
  }, [props?.state]);

  const handlePayment = () => {
    const card = getValues();
    const cpf_cnpj = cpf !== '' ? cpf : cnpj;
    setLoading(true);
    handle_payment({
      props,
      setLoading,
      card,
      assinatura,
      email,
      cupomObj,
      servico,
      cpf_cnpj,
      username,
      signaturePlan: signaturePlan ? { plan: signaturePlan, cupomObj } : null,
      id_payment: null,
      usuario: props.state.user,
      portal: props.state.portal,
    })
      .then((res) => {
        setMessage({
          text: 'Pagamento realizado com sucesso. Aguarde...',
          icon: 'check_circle_outline',
          color: 'green',
        });

        setTimeout(() => {
          setLoading(false);

          history.push({
            pathname: '/login',
            state: {
              isAbertura: props.state.type !== 'Service',
              isNewCadastro: true,
              usuario: username,
            },
          });
        }, 5000);
      })
      .catch((err) => {
        setLoading(false);

        const errorMessage =
          err?.response?.data?.message ||
          'Falha ao realizar pagamento, entre em contato!';

        setMessage({
          text: `ERROR: ${errorMessage}`,
          icon: 'remove_circle_outline',
          color: 'red',
        });

        return err;
      });
  };

  const validateCupom = async () => {
    const tipo_utilizacao =
      props.state.type === 'Signature' ? 'ASSINATURA' : 'SERVIÇOS';
    const cupom = getValues('cupom');

    const instance = instanceAxios();
    const response = await instance.post('/validarCupomOnCadadastro', {
      cupom,
      tipo_utilizacao,
    });

    if (!response) {
      setMessage({
        text: 'Não foi possivel aplicar cupom de desconto.',
        icon: 'remove_circle_outline',
        color: 'red',
      });
    }

    setMessage({
      text: response.data.message,
      icon: 'check_circle_outline',
      color: 'blue',
    });

    if (response.data.status === 'success') {
      setCupomObj(response.data);
    } else {
      setCupomObj(null);
    }
  };

  return (
    <div className={classes.root}>
      <Card className={classes.marginBottom}>
        <CardContent>
          <div className={classes.viewRow}>
            <Typography className={classes.textContent}>
              {nomeAssinatura}
            </Typography>
          </div>
          <div className={classes.viewRow}>
            <Typography className={classes.textContent}>
              {nomeServico}
            </Typography>
          </div>
        </CardContent>
      </Card>
      <Card className={classes.marginBottom}>
        <CardContent>
          <div className={classes.viewColumn}>
            <div>
              <Typography className={classes.label}>Valor</Typography>
              <Typography className={classes.textContent}>
                {formatMoney(Number(valorAssinatura) + valorServico)}
              </Typography>
              {cupomObj && (
                <>
                  <Typography className={classes.label}>
                    Valor final com desconto
                  </Typography>
                  <Typography className={classes.textContent}>
                    {formatMoney(
                      Number(valorAssinatura) +
                        valorServico -
                        cupomObj.valor / 100
                    )}
                  </Typography>
                </>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
      <Typography className={classes.textInfoCreditCard}>
        Cartão de Crédito
      </Typography>
      <FlagCards />
      <Controller
        name="titular"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            style={{ width: '100%' }}
            error={!!errors?.titular}
            helperText={errors?.titular ? errors.titular.message : ''}
            label="Titular do Cartão "
            id="titular"
            InputLabelProps={{ style: { fontSize: 16 }, shrink: true }}
            variant="outlined"
            autoFocus
          />
        )}
      />

      <Controller
        control={control}
        name="numCartao"
        defaultValue=""
        render={({ field: { onChange, onBlur, ref, value } }) => (
          <InputMask
            mask="9999 9999 9999 9999"
            value={value}
            onChange={onChange}
            onBlur={onBlur}
          >
            {(inputProps = ref) => (
              <TextField
                error={!!errors?.numCartao}
                helperText={errors?.numCartao ? errors.numCartao.message : ''}
                label="Número do Cartão"
                id="numCartao"
                variant="outlined"
                fullWidth
                required
                {...inputProps}
              />
            )}
          </InputMask>
        )}
      />

      <Controller
        name="validade"
        control={control}
        defaultValue=""
        render={({ field: { onChange, onBlur, ref, value } }) => (
          <InputMask
            mask="99/99"
            value={value}
            onChange={onChange}
            onBlur={onBlur}
          >
            {(inputProps = ref) => (
              <TextField
                placeholder="DD/YY"
                label="Validade"
                id="validade"
                style={{ width: '48.5%', marginRight: '3%' }}
                error={!!errors?.validade}
                helperText={errors?.validade ? errors.validade.message : ''}
                variant="outlined"
                fullWidth
                required
                {...inputProps}
              />
            )}
          </InputMask>
        )}
      />
      <Controller
        name="codigoCartao"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="CVV"
            error={!!errors?.codigoCartao}
            helperText={errors?.codigoCartao ? errors.codigoCartao.message : ''}
            InputProps={{
              style: { fontSize: 16 },
            }}
            style={{ width: '48.5%' }}
            InputLabelProps={{ style: { fontSize: 16 }, shrink: true }}
            id="codigoCartao"
            variant="outlined"
          />
        )}
      />

      <Controller
        name="cupom"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            style={{ width: '48.6%' }}
            className={classes.mr16}
            label="Cupom promocional"
            id="cupom"
            InputLabelProps={{ style: { fontSize: 16 }, shrink: true }}
            variant="outlined"
          />
        )}
      />

      <Button
        type="button"
        variant="contained"
        fullWidth
        className={classes.submit}
        style={{ width: '49.6%' }}
        onClick={() => validateCupom()}
        disabled={loading}
      >
        {loading ? <CircularProgress color="primary" size={25} /> : 'APLICAR'}
      </Button>

      <Button
        type="button"
        variant="contained"
        fullWidth
        disabled={!isValid || loading}
        className={classes.submit}
        onClick={() => handlePayment()}
      >
        {loading ? (
          <CircularProgress color="primary" size={25} />
        ) : (
          'CONFIRMAR SOLICITAÇÃO'
        )}
      </Button>

      {message.text !== '' && (
        <Typography style={{ color: message.color }}>
          <Icon className="text-20">{message.icon}</Icon> {message.text}
          {message.color === 'green' && (
            <CircularProgress color="primary" size={25} />
          )}
        </Typography>
      )}
    </div>
  );
}

export default FormCartao;
